<template>
  <div class="index">
    <h2>自动拉群中，不用操作_V5</h2>
    <input type="text" v-model="copyValue" ref="inputRef" autofocus style="position: absolute; left: -500px; top: -500px;">
  </div>
</template>

<script>
import {workEmployee, updateStatus, userCenter} from "../../api/homePage"
import {contactIndex} from '../../api/customer'
import { filterContact } from "../../api/roomTemplate";
import { openEnterpriseChat } from "../../utils/wxCodeAuth";
import {employeeIndex, contactTagList, store} from "../../api/channelCode";

export default {
  data() {
    return {
      sumCount: 0,
      continueWork: false, //粘贴进来了，人数没拿到的时候要用
      isStopPull: false,
      isYesterday: null,
      customerList: [],
      copyValue: '',
      groupName: '',
      limitNumber: null,
      groupList: [], //分好组的，一组39人
      startTime: undefined,
      endTime: undefined,
      tagName: null,
      spokesman: [],
      spokesmanExternalUserId: [],
    }
  },
  created() {
    
  },
  watch: {
    copyValue(newV, oldV) { //脚本粘贴了
        if(!this.isStopPull && newV) {
            this.isStopPull = !this.isStopPull
            this.$refs.inputRef.blur();
            this.groupName = newV.split("|")[0]
            this.limitNumber = Number(newV.split("|")[1])
            this.isYesterday = Number(newV.split("|")[2])
            this.startTime = newV.split("|")[3] ? JSON.parse(newV.split("|")[3])[0] : undefined
            this.endTime = newV.split("|")[3] ? JSON.parse(newV.split("|")[3])[1] : undefined

            this.tagName = newV.split("|")[4] ? newV.split("|")[4] : undefined
            this.spokesman = newV.split("|")[5] ? JSON.parse(newV.split("|")[5]).map(item=>item) : []

            this.continueWork = true
            if(this.spokesman.length){
                this.getSpokesmanExternalUserId()
            }else {
                this.getAllContact() //拿到值了再请求接口
            }

            console.log("脚本传送",
            this.limitNumber,
            this.isYesterday,
            this.startTime,
            this.endTime,
            this.tagName
            )

            
        }
    },
    sumCount(newV, oldV) { //人数列表请求拿到了
        if(this.continueWork && newV > 0) {
            this.startPullRoom()
        }
    }
  },
  methods: {
    getSpokesmanExternalUserId() {
        filterContact({}).then((res) => {
            this.spokesmanExternalUserId = []
            res.data.list.forEach(item=>{
                for(let i=0; i<this.spokesman.length;i++) {
                    if((item.type==2 && item.name == this.spokesman[i])){
                        this.spokesmanExternalUserId.push(item.wxExternalUserid)
                    }
                }
            })
            if(this.spokesmanExternalUserId.length){
                this.getAllContact()
            }
        })
    },
    // wxUserId
    getAllContact () {
        // contactIndex({
        //     employeeId: this.$route.query.id,
        //     status: 1,
        //     page: 1,
        //     perPage: 10000
        // }).then(res=>{
            
        // })

        if(this.startTime && this.endTime && this.tagName) {
            
            contactTagList().then(res => {
                console.log("tagRes",res.data)
                let tags = res.data.map(item => {
                    if(item.tags.find(it=> it.name == this.tagName)) {
                        return item.tags.find(it=> it.name == this.tagName).id
                    }
                })
                
                filterContact({
                    startTime: this.startTime, 
                    endTime: this.endTime, 
                    tags: tags
                }).then((res) => {
                    this.customerList = res.data.list.filter(item=>item.type==1);
                    this.sumCount = this.customerList.length;
                })
            })
            
            
        }else if(this.tagName && !this.startTime && !this.endTime){
            contactTagList().then(res => {
                let tags = res.data.map(item => {
                    if(item.tags.find(it=> it.name == this.tagName)) {
                        return item.tags.find(it=> it.name == this.tagName).id
                    }
                })
                
                filterContact({
                    tags: tags
                }).then((res) => {
                    this.customerList = res.data.list.filter(item=>item.type==1);
                    this.sumCount = this.customerList.length;
                })
            })
        }else if(!this.tagName && this.startTime && this.endTime){
            filterContact({
                startTime: this.startTime, 
                endTime: this.endTime
            }).then((res) => {
                this.customerList = res.data.list.filter(item=>item.type==1);
                this.sumCount = this.customerList.length;
            })
        }else {
            filterContact({}).then((res) => {
                this.customerList = res.data.list.filter(item=>item.type==1);
                this.sumCount = this.customerList.length;
            })
        }
    },
    async startPullRoom() {
        let maxNum = 39 - this.spokesmanExternalUserId.length
        let wxUserId = this.$route.query.wxUserId
        this.groupList = []

        if (this.sumCount <= maxNum) {

            let externalUserIds

            if(this.spokesmanExternalUserId.length) {
                let tem = this.customerList
                .map((i) => {
                    return i.wxExternalUserid;
                });
                for(let i=0; i<this.spokesmanExternalUserId.length; i++) {
                    tem.unshift(this.spokesmanExternalUserId[i]);
                }
                externalUserIds = tem.join(";");
            }else {
                externalUserIds = this.customerList
                .map((i) => {
                    return i.wxExternalUserid;
                })
                .join(";");
            }

            this.groupList = [{
                id: 0,
                groupName: this.groupName,
                groupNum: this.sumCount + 1,
                externalUserIds: externalUserIds,
                wxUserId: wxUserId,
                isClick: false,
            }];

        } else {
            //大于39了。就拆分多个群组 每个搞成39人。
            let groupNum = Math.ceil(this.sumCount / maxNum);
            let rnum = this.sumCount % maxNum;
            for (let i = 0; i < groupNum; i++) {
                let group = {
                    id: i,
                    groupName: this.groupName + "-" + (i+1),
                    groupNum: maxNum + 1,
                    externalUserIds: [],
                    wxUserId: wxUserId,
                    isClick: false,
                };
                if (i == groupNum - 1) {
                    group.groupNum = rnum + 1;
                }
                let groupIds = [];
                for (let j = 0; j < maxNum; j++) {
                    let index = i * maxNum + j;
                    if (index >= this.sumCount) {
                    break;
                    }
                    groupIds.push(this.customerList[index].wxExternalUserid);
                }

                if (this.spokesmanExternalUserId.length) {
                    for(let i=0; i<this.spokesmanExternalUserId.length; i++) {
                        groupIds.unshift(this.spokesmanExternalUserId[i]);
                    }
                }
                
                group.externalUserIds = groupIds.join(";");
                this.groupList.push(group);
            }
            
        }

        console.log("看看this.groupList",this.groupList)
        switch(this.isYesterday){ //【0不管昨天】，【1优先拉昨天，接着拉今天】，【2只拉昨天的，不拉今天】
            case 0: {
                this.limitSave()
                await this.orderPullRomm(this.groupList)
                break;
            }
            case 1: {
                if(!!localStorage.getItem('saveGroupList')) {
                    let toDayList = this.groupList
                    this.groupList = [...JSON.parse(localStorage.getItem('saveGroupList')).concat(toDayList)]
                }
                this.limitSave()
                await this.orderPullRomm(this.groupList)
                break;
            }
            case 2: {
                if(!!localStorage.getItem('saveGroupList')) {
                    this.groupList = [...JSON.parse(localStorage.getItem('saveGroupList'))]
                    this.limitSave()
                    await this.orderPullRomm(this.groupList)
                    break;
                }
            }
        }
        
    },
    limitSave() {
        if(this.groupList.length > this.limitNumber) { //超出的存起来，明天拉
            let saveArr = this.groupList.filter((item,index)=>index>=this.limitNumber)
            // 基本存储
            localStorage.setItem('saveGroupList', JSON.stringify(saveArr));
            console.log("看看保存的昨天值",JSON.stringify(saveArr))
        }else {
            // 删除单个数据
            localStorage.removeItem('saveGroupList');
        }
    },
    async orderPullRomm(array) {
        for (let i = 0; i < (array.length<this.limitNumber ? array.length : this.limitNumber); i++) {
            
            await openEnterpriseChat(
                array[i].wxUserId,
                array[i].externalUserIds,
                array[i].groupName,
                ''
            );  
        }  
    }
  }

}
</script>

<style lang="less" scoped>

</style>
